// Free members pick one streaming service at a time (tapping another
// switches to it); Premiere members can combine several. The server
// enforces the same rule (availability_gate.cap_services_for_free).
export function nextServiceSelection(prev, name, isPremium, { keepOne = false } = {}) {
  if (!isPremium) {
    if (prev.length === 1 && prev[0] === name) return keepOne ? prev : [];
    return [name];
  }
  if (prev.includes(name)) {
    const next = prev.filter((s) => s !== name);
    return keepOne && !next.length ? prev : next;
  }
  return [...prev, name];
}

export const capServicesForFree = (list, isPremium) =>
  isPremium ? list || [] : (list || []).slice(0, 1);
